import { Card, CardTitle, CardDescription } from "@tellescope/ui";
import { useDashboardInboxData } from "../hooks/useDashboardInboxData";
import { useTranslation } from "react-i18next";
import { InboxThreadListDefaultItem } from "../../messaging/components/thread-list-panel/list-items/InboxThreadListDefaultItem";
import { PermissionWrapper } from "../../../components/PermissionWrapper";

export interface DashboardMessagesContainerProps {
  className?: string;
  messageLimit?: number;
}

export function DashboardMessagesContainer({ className = "", messageLimit = 10 }: DashboardMessagesContainerProps) {
  const { t } = useTranslation("dashboard");

  // Use real data hook
  const { threads, isLoading, error } = useDashboardInboxData(messageLimit);

  return (
    <PermissionWrapper model="inbox_threads" action="read">
      <Card className={`px-6 ${className}`}>
        {/* Header */}
        <div className="grid flex-1 gap-1">
          <CardTitle>{t("Messaging activity")}</CardTitle>
          <CardDescription>{t("View and respond to customer messages")}</CardDescription>
        </div>

        {/* Scrolling list of messages */}
        <div className="h-[600px] overflow-y-auto space-y-4">
          {isLoading ? (
            <div className="flex items-center justify-center h-32">
              <div className="text-sm text-muted-foreground">{t("Loading messages...")}</div>
            </div>
          ) : error ? (
            <div className="flex items-center justify-center h-32">
              <div className="text-sm text-destructive">
                {t("Error loading messages: {{error}}", { error: error.message })}
              </div>
            </div>
          ) : threads.length === 0 ? (
            <div className="flex items-center justify-center h-32">
              <div className="text-sm text-muted-foreground">{t("No messages found")}</div>
            </div>
          ) : (
            threads.map((thread) => (
              <InboxThreadListDefaultItem key={thread.id} thread={thread} isSelected={false} className="shadow-none" />
            ))
          )}
        </div>
      </Card>
    </PermissionWrapper>
  );
}
